import Table from '@codegouvfr/react-dsfr/Table';
import React from 'react';

export const PolitiqueCookies = () => {
  return (
    <div className="max-w-[1200px] mx-auto px-6 py-10 bg-white">
      <h1>Politique de gestion des cookies du site Mon Activité Apprentissage</h1>
      <p className="text-sm text-[#666] mb-8">Version 1 du 04/05/2026</p>

      <section className="mb-8">
        <h2>1. Le Responsable de traitement</h2>
        <p>
          Le site <a
          href={'https://ofa-map-apprentissage.francecompetences.fr'}>https://ofa-map-apprentissage.francecompetences.fr</a> ,
          désigné ci-après « le site de Mon Activité
          Apprentissage », est édité par France compétences, institution nationale publique créée par la loi n° 2018-771
          du 5 septembre 2018 pour la liberté de choisir son avenir professionnel (décret paru au J.O. du 30 décembre
          2018), immatriculée sous le numéro SIRET 130 024 565 00025 et dont le siège social est situé au 6 Rue du
          Général Audran à Courbevoie (92400).
        </p>
        <p>
          La présente politique a pour objectif de décrire en toute transparence les règles de gestion des cookies
          utilisés sur le site de Mon Activité Apprentissage.
        </p>
      </section>

      <section className="mb-8">
        <h2>2. Qu’est-ce qu’un « Cookie » </h2>

        <p>
          Un cookie est une information déposée sur le terminal de l’internaute (ordinateur, mobile, tablette…) par le
          serveur du site de Mon Activité Apprentissage. Ce dernier implante un cookie sur votre terminal pour
          enregistrer des informations relatives à votre navigation, et permet à son émetteur d’identifier le terminal
          sur lequel il est enregistré, pendant la durée de validité dudit cookie.
        </p>

        <h3>Les cookies presents sur le site de Mon Activité Apprentissage</h3>

        <p>Les cookies présents sur le site de Mon Activité Apprentissage sont des cookies nécessaires au fonctionnement
          du site. Le site Mon Activité Apprentissage utilise uniquement des cookies nécessaires à l’utilisation du site
          : il s’agit des cookies indispensables à la navigation qui vous permettent d’utiliser les principales
          fonctionnalités du site et de sécuriser votre connexion. Ces cookies sont exclusivement émis par France
          compétences.</p>

        <p>Sur son site internet, Mon Activité Apprentissage a recours aux cookies essentiels à la navigation suivants
          :</p>

        <p>
          <strong>Nom du cookie :</strong> Lemonldap<br />
          <strong>Finalité(s) </strong> Cookie SSO pour l'authentification intra-domaine<br />
          <strong> Durée de conservation :</strong> Fermeture du navigateur (pas de l'onglet)<br />
        </p>

      </section>

      <section className="mb-8">
        <h2>3. Modalités de désactivation des cookies </h2>

        <p>
          Les cookies présents sur le site de Mon Activité Apprentissage étant des cookies nécessaires à son
          fonctionnement, ils ne sont pas soumis au consentement de l’utilisateur du site.
        </p>

        <h3>Vous avez également la possibilité de paramétrer le choix de votre navigateur pour la gestion des cookies
          :</h3>

        <ul className="list-disc pl-6">
          <li>Pour Internet Explorer :
            <a
              href={'https://support.microsoft.com/fr-fr/help/17442/windows-internet-explorer-delete-manage-cookies'}>https://support.microsoft.com/fr-fr/help/17442/windows-internet-explorer-delete-manage-cookies</a>
          </li>
          <li>Pour Apple Safari : <a
            href={'https://support.apple.com/fr-fr/guide/safari/sfri11471/mac'}>https://support.apple.com/fr-fr/guide/safari/sfri11471/mac</a>
          </li>
          <li>Pour Google Chrome : <a
            href={'https://support.google.com/chrome/answer/95647?hl=fr&hlrm=en'}>https://support.google.com/chrome/answer/95647?hl=fr&hlrm=en </a>
          </li>
          <li>Pour Mozilla Firefox :
            <a
              href={'https://support.mozilla.org/fr/kb/protection-renforcee-contre-pistage-firefox-ordinateur?redirectlocale=fr&redirectslug=Activer+et+d%C3%A9sactiver+les+cookies'}>https://support.mozilla.org/fr/kb/protection-renforcee-contre-pistage-firefox-ordinateur?redirectlocale=fr&redirectslug=Activer+et+d%C3%A9sactiver+les+cookies</a>
          </li>
          <li>Pour Opera : <a
            href={'https://help.opera.com/en/latest/web-preferences/#cookies'}>https://help.opera.com/en/latest/web-preferences/#cookies</a>
          </li>
        </ul>

      </section>

      <section className="mb-8">
        <h2>4. Coordonnées du DPO </h2>

        <p>
          Pour exercer vos droits, les personnes concernées peuvent écrire au Délégué à la protection des données (DPO)
          de France compétences :
        </p>

        <ul className="list-disc pl-6">
          <li><strong>Par courriel : </strong>dpo@francecompetences.fr
          </li>
          <li><strong>Par courrier : </strong>DPO France compétences<br />
            HAAS AVOCATS<br />
            6, rue de Saint-Pétersbourg 75008 Paris)<br />
          </li>
        </ul>

        <p>Enfin, vous pouvez également introduire une réclamation auprès des autorités de contrôle et notamment de la
          CNIL (https://www.cnil.fr/fr/plaintes). </p>


      </section>

      <section className="mb-8">
        <h2>5. Plus d'informations sur les cookies ? </h2>
        <p>Si vous souhaitez plus d’informations concernant les cookies, vous pouvez consulter le site de la CNIL :
          <a
            href={'https://www.cnil.fr/fr/site-web-cookies-et-autres-traceurs'}>https://www.cnil.fr/fr/site-web-cookies-et-autres-traceurs</a>.
        </p>
      </section>

      <section className="mb-8">
        <h2>6. Modification de la présente politique ? </h2>
        <p>France compétences est susceptible de modifier la présente politique de gestion des cookies en tant que de
          besoin. Nous veillerons à ce que vous soyez informés de ces modifications par une mention spéciale sur le site
          de France compétences ou par un courriel d’information.
        </p>
      </section>


    </div>
  );
};